import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/I18nContext";

// Eye-catching entry to /videos: gentle gold/red glow pulse (static with prefers-reduced-motion).
export const VideosButton = ({ testId = "videos-cta", compact = false }) => (
  <Inner testId={testId} compact={compact} />
);

const Inner = ({ testId, compact }) => {
  const { t } = useI18n();
  return (
    <Link to="/videos" className={`videos-pulse inline-flex max-w-full items-center gap-2 whitespace-normal break-words rounded-full border border-[var(--gold)] bg-[linear-gradient(90deg,#d0141f,#a30f18)] font-display font-bold uppercase tracking-wider text-white ${compact ? "px-3 py-1.5 text-[0.7rem]" : "px-5 py-2.5 text-sm"}`}
      data-testid={testId}>
      {t("videos.cta")}
    </Link>
  );
};
